<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Forgot Password?</h1>
              <p class="text-lead text-white">No Problem, We got you!</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="ard-profile bg-secondary mt-5">
            <b-row class="justify-content-center">
              <b-col lg="3" class="order-lg-2">
                <div class="card-profile-image">
                  <b-img
                    src="img/theme/team-4.jpg"
                    rounded="circle"
                    class="border-secondary"
                  />
                </div>
              </b-col>
            </b-row>
            <b-card-body class="pt-7 px-5">
              <b-form role="form">
                <base-input
                  alternative
                  prepend-icon="ni ni-email-83"
                  type="email"
                  placeholder="email"
                  v-model="model.email"
                >
                </base-input>
                <div class="text-center">
                  <base-button type="primary" class="mt-2" @click="OnReset"
                    >Send Reset Link</base-button
                  >
                </div>
              </b-form>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/auth/login" class="text-light"
                ><small>Back to Login</small></router-link
              >
            </b-col>
            <b-col cols="6" class="text-right">
              <router-link to="/auth/register" class="text-light"
                ><small>Create new account</small></router-link
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { reset } from "../../util/api";
import swal from "sweetalert2";
export default {
  name: "forgotpassword",
  data() {
    return {
      model: {
        email: ""
      }
    };
  },
  methods: {
      OnReset() {
      reset(this.model.email).then((res, err) => {
        try {
             if(err) throw err.message;
            console.log(res)
          swal.fire({
            title: `Reset Link Sent to your email`,
            buttonsStyling: false,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill"
          });
        } catch (e) {
          swal.fire({
            title: `${e}`,
            buttonsStyling: false,
            type: "warning",
            confirmButtonClass: "btn btn-danger btn-fill"
          });
        }
      });
    }
  }
};
</script>
<style></style>
